<template>
  <div class="modal contacts-success" v-if="canIShowPhoneAlreadyExist">
    <div class="modal__content">
      <div class="modal__close" @click="showPhoneAlreadyExist(false)"></div>
      <h3 class="modal__title">Ой!</h3>
      <div class="modal__main">
        <div class="modal__text no-drug-stores">
          Користувач з таким номером телефону вже зареєстрований
        </div>
        <div class="modal__options">
          <a
            href="#"
            class="modal__btn modal__btn_yellow"
            @click.prevent="showPhoneAlreadyExist(false)"
            >Ок</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "PhoneAlreadyExist",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["canIShowPhoneAlreadyExist"])
  },
  methods: {
    ...mapMutations(["showPhoneAlreadyExist"])
  }
};
</script>
